import styled from "styled-components";
export const Main = styled.div<{
  primaryColor: string;
  $loading: boolean;
  clientName: string;
}>`
  /* START TOOLTIP STYLES */
  [tooltip] {
    position: relative;
    animation: tooltips-horz 300ms ease-out forwards;
    animation-duration: 3s;
    pointer-events: all;
    /* opinion 1 */
  }

  /* Applies to all tooltips */
  [tooltip]::before,
  [tooltip]::after {
    text-transform: none; /* opinion 2 */
    font-size: 0.6em; /* opinion 3 */
    line-height: 1;
    position: absolute;
    display: block;
    opacity: 1;
    pointer-events: all;
  }
  [tooltip]::before {
    content: "";
    border: 5px solid transparent; /* opinion 4 */
    z-index: 1001; /* absurdity 1 */
  }
  [tooltip]::after {
    content: attr(tooltip); /* magic! */

    /* most of the rest of this is opinion */
    text-align: left;

    /*
    Let the content set the size of the tooltips
    but this will also keep them from being obnoxious
    */
    min-width: 3em;
    width: 9em;
    max-width: 21em;
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1.5ch 1.5ch;
    border-radius: 5px;
    box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.12);
    background: #fff;
    color: #000;
    z-index: 1000; /* absurdity 2 */
  }

  /* FLOW: LEFT */
  [tooltip][flow^="left"]::before {
    top: 50%;
    border-left-color: #e9e9eb;
    left: calc(0em - 5px);
    transform: translate(-0.5em, -50%);
  }
  [tooltip][flow^="left"]::after {
    top: 50%;
    right: calc(100% + 5px);
    transform: translate(-0.5em, -50%);
  }

  /* KEYFRAMES */
  @keyframes tooltips-vert {
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  @keyframes tooltips-horz {
    to {
      opacity: 1;
      transform: translate(0, -50%);
    }
  }

  /* FX All The Things */

  [tooltip][flow^="left"]:hover::before,
  [tooltip][flow^="left"]:hover::after,
  [tooltip][flow^="right"]:hover::before,
  [tooltip][flow^="right"]:hover::after {
    animation: tooltips-horz 300ms ease-out forwards;
  }

  .rcw-launcher {
    background: ${(props) => props.primaryColor};
  }

  .rcw-messages-container {
    background-color: #fff important;
  }
  .chat-message {
    white-space: pre-line;
    overflow-wrap: break-word;
  }

  .rcw-new-message {
    padding-right: 12px; /*overrides 36px*/
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-shadow: rgba(0, 0, 0, 0.04) 0px 12px 36px 0px;
  }

  .rcw-input::-webkit-scrollbar {
    /*removing scrollbar;keeping scroll function*/
    display: none;
  }

  .rcw-input {
    /*removing scrollbar;keeping scroll function*/
    -ms-overflow-style: none; /*IE&Edge*/
    scrollbar-width: none; /*Firefox*/
  }

  .rcw-response {
    white-space: pre-line;
  }
  .rcw-conversation-container {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 12px 48px 4px !important;
    overflow: hidden;
  }

  .rcw-conversation-container .rcw-header {
    background-color: ${(props) => props.primaryColor} !important;
    text-align: left !important;
    padding: 8px 15px;
    height: 56px;
    display: flex;
    justify-content: center;
  }
  .rcw-response .rcw-message-text {
    max-width: 300px;
  }

  .rcw-conversation-container .rcw-title {
    line-height: 1.5;
    padding: 0;
    font-size: 16px;
    line-height: 16px;
    margin: 0;
  }

  .rcw-conversation-container .avatar {
    height: 28px;
    width: 28px;
  }

  .button {
    background-color: #fff;
    color: #000;
    box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.12);
    transition: 0.3s;
    border-radius: 8px;
    border: 1px solid rgba(1, 0, 0, 0.05);
    text-decoration: none;
    font-family: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: flex-end;
    font-size: 1.5rem;
    padding: 6px;
    margin-top: 10px;
    bottom: 0;
  }

  .button:hover {
    box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.12);
  }

  .button img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
  .bot_name {
    font-size: 16px;
    font-weight: bolder;
  }
  .heading_text {
    font-size: 14px;
  }
  .container_div {
    text-align: start;
    padding-left: 5px;
  }
  .btn_close {
    background-color: transparent;
    margin-top: 8px;
    border: 0;
    color: white;
    padding: 12px 16px;
    font-size: 16px;
    cursor: pointer;
    position: absolute;
    align-self: end;
  }
  .btn_close_2 {
    margin-bottom: 60px;
    color: white;
    top: 10;
  }

  .rcw-widget-container {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;

    max-height: 650px;
    min-height: 142px;
    transform: translateY(0);
  }

  .rcw-tooltip-button {
    position: relative;
    display: inline-block;
  }
  .rcw-tooltip-button[title]:not([title=""])::after {
    content: attr(title);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 5px;
    border-radius: 3px;
    position: absolute;
    bottom: 40%; /* Position the tooltip above the button */
    left: 50%;
    transform: translateX(-100%);
    white-space: pre;
    opacity: 0;
    overflow-wrap: break-word;
    transition: opacity 0.3s;
  }
  .rcw-tooltip-button[title]:not([title=""]):hover::after {
    opacity: 1;
  }

  .rcw-message {
    margin: 2px 8px 2px 8px;
  }
  .rcw-client .rcw-message-text {
    padding: 8px;
    background-color: ${(props) => props.primaryColor};
    color: #fff;
  }
  .rcw-response .rcw-message-text {
    white-space: ${(props) => (props.$loading ? "pre-line" : "pre-line")};
  }
  .rcw-send {
    display: flex;
    align-items: center;
    // min-height: 38px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    margin: 0px 0 0px 7px;
    justify-content: center;
    // min-width: 40px;
    padding: 10px;
  }
  .rcw-sender {
    align-items: center;
  }

  @media screen and (max-width: 800px) {
    .button {
      bottom: 0;
      margin: 0;
      position: fixed;
      right: 0;
      align-self: flex-end;
    }

    .rcw-widget-container {
      max-height: 100%;
      width: 100%;
      transform: translateY(0);
    }

    .rcw-conversation-container .rcw-close-button {
      display: ${(props) =>
        props.clientName === "aarp" ||
        props.clientName === "veterans" ||
        props.clientName === "neda" ||
        props.clientName === "dcf"
          ? "none"
          : "flex"};
    }
    .rcw-launcher-2 {
      color: #fff;
      border: none;
      top: 20px;
      background: inherit;
      box-shadow: none;
      display: flex;
      border-radius: 0;
      width: 25px;
      height: 20px;
      right: 10px;
      position: absolute;
      font-size: 26px;
    }

    /*hiding close via styling*/
    .rcw-close {
      display: none;
    }

    .rcw-close-button {
      top: 10;
      background: inherit;
      box-shadow: none;
      display: flex;
      border-radius: 0;
      width: 25px;
      height: 20px;
    }
  }
`;

export const Button = styled.button`
  background: white;
  color: #50647c;
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid #cecece; /* gray */
  border-radius: 12px;
  transition-duration: 0.4s;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background-color: #cecece;
    color: white;
  }
  pointer-events: ${(props) => (props.disabled ? "none" : null)};

  max-width: 150px;
  max-height: 50px;

  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
`;
